export { default as AdStatusLabel } from "./AdStatusLabel";



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/MyAdsCard/AdStatusLabel/index.ts